import type { Listing } from "@b2bportal/homes-api";
import type { Lodging } from "@b2bportal/lodging-api";
import { getAddressText } from "@overrides/utilities";

export const useGetMapInfoFromStay = (stay: Lodging | Listing) => {
  const isHome = "content" in stay;

  if (isHome) {
    return {
      coordinates: stay.content.location.exactCoordinates,
      hotelName: stay.content.name,
      address: getAddressText(stay.content.location.address),
    };
  }
  return {
    coordinates: stay.lodging.location.coordinates,
    hotelName: stay.lodging.name,
    address: getAddressText(stay.lodging.address),
  };
};
